//@ts-strict-ignore
import React, { useContext } from 'react';
import ContextMenuItem from '../../../components/ContextMenuItem';
import { useReturnOrderFromOrderMutation } from '../../../utils/SalesOrderHooks';
import ConnectedFormContext from '../../../components/Context/ConnectedFormContext';
import { checkLinePriceApprovalButton, checkLinePriceApproved } from '../../../utils/LineUtils';

const ReturnOrderContextMenuItem = ({ rowIdx }) => {
  const connectedForm = useContext(ConnectedFormContext);
  const selectedOrderLine = connectedForm.values?.orderLines?.[rowIdx];
  const { raiseReturn } = useReturnOrderFromOrderMutation();

  return (
    <ContextMenuItem
      key={'raiseReturn'}
      onClick={() => {
        raiseReturn({ originLines: [selectedOrderLine] });
      }}
      label={'Raise Return'}
      rowIdx={rowIdx}
      available={checkLinePriceApproved(selectedOrderLine) ?? true}
    />
  );
};

export default ReturnOrderContextMenuItem;
